import { Joseph } from './joseph'

export const JosephSd = {
  ...Joseph,
  sociallyDistanced: true
}
